import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

const initReviewSliderSections = () => {
    [...document.querySelectorAll('.review-slider-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initReviewSliderSection(item));
};

const initReviewSliderSection = (section) => {
    section.dataset.init = true;
    const slider = section.querySelector('.review-slider-items');
    const swiper = new Swiper(slider, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: true,
    });
    section.addEventListener('click', e => {
        const prevButton = e.target.closest('.swiper-button-prev');
        if(prevButton) {
            swiper.slidePrev();
            return;
        }
        const nextButton = e.target.closest('.swiper-button-next');
        if(nextButton) {
            swiper.slideNext();
            return;
        }
    })
};

export { initReviewSliderSections };